import { merchantStatic } from "@/app/data";
import { CommonImage } from "@/components/common";
import { Button } from "@/components/ui/button";
import React from "react";

interface HeroButton {
  title?: string;
  link?: string;
  showIcon?: boolean;
}

interface HeroBtnGroupProps {
  primaryButton?: HeroButton;
  secondaryButton?: HeroButton;
  className?: string;
}

export default function HeroBtnGroup({
  primaryButton,
  secondaryButton,
  className,
}: HeroBtnGroupProps): React.ReactNode {
  const primary =
    primaryButton ?? {
      title: merchantStatic.heroSection.googlePlayDownload.title,
      link: merchantStatic.heroSection.googlePlayDownload.link,
    };

  const secondary =
    secondaryButton ?? {
      title: merchantStatic.heroSection.appStoreDownload.title,
      link: merchantStatic.heroSection.appStoreDownload.link,
    };

  return (
      <div className={`flex sm:flex-row flex-col gap-3 items-start ${className || ''}`}>
      <a target="_blank" href={primary.link} className="w-full">
        <Button className="w-full h-12 sm:h-10">
          {primary.showIcon && (
            <CommonImage
              width={20}
              height={20}
              alt="Google Play icon"
              src="/icons/google-play-fill.svg"
            />
          )}
          <p className="font-medium text-white tracking-[0] leading-5 whitespace-nowrap">
            {primary.title}
          </p>
        </Button>
      </a>
      <a target="_blank" href={secondary.link} className="w-full">
        <Button className="w-full h-12 sm:h-10" variant="outlineb">
          {primary.showIcon && (
            <CommonImage
              width={20}
              height={20}
              alt="Apple icon"
              src="/icons/apple.svg"
            />
          )}
          <p className="font-semibold text-white ">{secondary.title}</p>
        </Button>
      </a>
    </div>
  );
}
